import { EventEmitter } from '../util/eventemitter';

export class Effect extends EventEmitter {
  rootObj: any;
  rootObj2: any;
  isPlaying: boolean;
  particleEffects: any[];
  animations: any[];

  static STATE = {
    READY_TO_PLAY: 0,
    PLAYING: 1,
    STOPPED: 2
  };

  constructor() {
    super();

    this.rootObj  = new THREE.Object3D();
    this.rootObj2 = new THREE.Object3D();

    this.isPlaying = false;
    this.particleEffects = [];
    this.animations = [];
  }

  resetBlendWeights() {
    // Needed for THREE.AnimationHandler
  }

  play() {
    this.isPlaying = true;
    THREE.AnimationHandler.play(this);

    for (let i = 0; i < this.particleEffects.length; ++i) {
      this.particleEffects[i].play();
    }

    for (let i = 0; i < this.animations.length; ++i) {
      this.animations[i].play();
    }
  }

  stop() {
    this.isPlaying = false;
    THREE.AnimationHandler.stop(this);

    for (let i = 0; i < this.particleEffects.length; ++i) {
      this.particleEffects[i].stop();
    }

    for (let i = 0; i < this.animations.length; ++i) {
      this.animations[i].stop();
    }
  }

  update(delta: any) {
    if (!this.isPlaying) {
      return;
    }

    let areAnyPlaying = false;
    for (let i = 0; i < this.particleEffects.length; ++i) {
      this.particleEffects[i].update(delta);

      if (this.particleEffects[i].state !== Effect.STATE.STOPPED) {
        areAnyPlaying = true;
      }
    }

    for (let i = 0; i < this.animations.length; ++i) {
      this.animations[i].update(delta);

      if (this.animations[i].state !== Effect.STATE.STOPPED) {
        areAnyPlaying = true;
      }
    }

    if (!areAnyPlaying) {
      this.isPlaying = false;
      this.emit('finish');
    }
  }
}

export class EffectParticle {
  rootObj: any;
  subRootObj: any;
  emitters: any[];
  startDelay: number;
  animation: any;
  state: number;
  path: any;

  constructor() {
    this.rootObj = new THREE.Object3D();
    this.subRootObj = null;
    this.emitters = [];
    this.startDelay = 0;
    this.animation = null;
    this.state = Effect.STATE.READY_TO_PLAY;
  }

  play() {
    // Initialise stuff to play
  }

  pause() {
    // TODO: Make this actually work properly
    this.state = Effect.STATE.STOPPED;
  }

  stop() {
    // Make shit stop
    this.state = Effect.STATE.STOPPED;
  }

  deleteAllParticles() {
    for (let i = 0; i < this.emitters.length; ++i) {
      this.emitters[i].deleteAllParticles();
    }
  }

  update(delta: any) {
    if (this.state === Effect.STATE.READY_TO_PLAY) {
      this.startDelay -= delta;

      if (this.startDelay <= 0) {
        this.state = Effect.STATE.PLAYING;

        if (this.animation) {
          this.animation.play();
        }

        delta = -this.startDelay;
      }
    }

    if (this.state === Effect.STATE.PLAYING) {
      let isRunning = false;
      for (let i = 0; i < this.emitters.length; ++i) {
        const emitter = this.emitters[i];
        if (emitter.update(delta)) {
          isRunning = true;
        }
      }
      if (this.animation && !this.animation.isPlaying) {
        isRunning = false;
      }
      if (!isRunning) {
        this.pause();
        this.deleteAllParticles();
      }
    }
  }
}

const totalStarted = 0;

export class EffectAnimation {
  rootObj: any;
  subRootObj: any;
  state: number;
  startDelay: number;
  animation: any;
  material: any;
  mesh: any;
  meshAnimation: any;
  name: any;
  loop: any;

  constructor() {
    this.rootObj = new THREE.Object3D();
    this.subRootObj = null;
    this.state = Effect.STATE.READY_TO_PLAY;
    this.startDelay = 0;
    this.animation = null;
    this.material = null;
    this.mesh = null;
    this.meshAnimation = null;
  }

  play() {
    // Initialise stuff to play
  }

  pause() {
    // Make this work properly
    this.state = Effect.STATE.STOPPED;
  }

  stop() {
    // Make shit stop
  }

  update(delta: any) {
    if (this.state === Effect.STATE.READY_TO_PLAY) {
      this.startDelay -= delta;

      if (this.startDelay <= 0) {
        this.state = Effect.STATE.PLAYING;

        if (this.animation) {
          this.animation.once('finish', function(this: any) {
            this.animation.stop();
          }.bind(this));
          this.animation.play();
        }

        if (this.meshAnimation) {
          this.meshAnimation.once('finish', function(this: any) {
            this.meshAnimation.stop();
            this.pause();
          }.bind(this));
          this.meshAnimation.play();
        }

        delta = -this.startDelay;
      }
    }
  }
}

